/**
 * Mobile Empty State Component
 * Provides beautiful empty states with illustrations and CTAs
 */

import React from 'react';
import { motion } from 'framer-motion';
import { ThemedButton } from './ui/ThemedButton';
import MobileCard from './MobileCard';

const MobileEmptyState = ({
  icon = '📭',
  title = 'Nothing here yet',
  description = 'Get started by adding your first item',
  actionLabel,
  onAction,
  variant = 'default',
  className = '',
}) => {
  const variants = {
    default: 'text-gray-400',
    success: 'text-green-400',
    warning: 'text-yellow-400',
    danger: 'text-red-400',
  };

  return (
    <MobileCard variant="elevated" className={`text-center py-8 ${className}`}>
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ 
          type: 'spring', 
          stiffness: 200, 
          damping: 15,
          delay: 0.1 
        }}
        className="text-6xl mb-4"
      >
        {icon}
      </motion.div>
      
      <motion.h3
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        className={`text-xl font-semibold mb-2 ${variants[variant]}`}
      >
        {title}
      </motion.h3>
      
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3 }}
        className="text-gray-400 text-sm mb-6 px-4"
      >
        {description}
      </motion.p>
      
      {actionLabel && onAction && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
        >
          <ThemedButton
            variant="primary"
            onClick={onAction}
            size="md"
            className="mx-auto"
          >
            {actionLabel}
          </ThemedButton>
        </motion.div>
      )}
    </MobileCard>
  );
};

export default MobileEmptyState;







